
import { formatDate, formatDateNoHours } from "~/utils/common";
export default {
  props: [
    "title",
    "status",
    "thumb",
    "linkTo",
    "registion_start_time",
    "registion_end_time",
  ],
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      mediaUrl: this.$config.BASE_URL_RESOURCE,
      startTime: formatDateNoHours(this.registion_start_time),
    };
  },

  computed: {
    isExpired() {
      const isExpired = new Date() > new Date(this.registion_end_time);
      return isExpired;
    },
    // formatDate(){
    //   formatDate(this.registion_start_time)
    // }
  },
};
